import { CheckIcon } from '@heroicons/react/24/outline';

export const CARD_FLAGS_CONTAINER_DATA_CY = {
  desktop: 'listing-card-desktop-flags',
  mobile: 'listing-card-mobile-flags',
} as const;

export const CARD_FLAG_DATA_CY = {
  onsitePayment: 'listing-card-payment-onsite',
  immediateConfirmation: 'listing-card-immediate-confirmation',
} as const;

interface CardFlagsProps {
  hasAvailableSlots: boolean;
  paymentFlags: {
    hasOnsitePayment: boolean;
    hasImmediateConfirmation: boolean;
  };
  isWelfare: boolean;
  isIntegrated?: boolean;
}

export const CardFlags = ({ hasAvailableSlots, paymentFlags, isWelfare, isIntegrated }: CardFlagsProps) => {
  return (
    <>
      {hasAvailableSlots && paymentFlags.hasOnsitePayment && !isWelfare && (
        <span
          data-cy={CARD_FLAG_DATA_CY.onsitePayment}
          className="inline-flex items-center gap-1 rounded-full bg-[#EFEAFF] px-2 py-0.5 text-xs font-medium text-[#4B3FA8]"
        >
          <CheckIcon className="size-3" />
          Pagamento in sede
        </span>
      )}
      {hasAvailableSlots && paymentFlags.hasImmediateConfirmation && isIntegrated && (
        <span
          data-cy={CARD_FLAG_DATA_CY.immediateConfirmation}
          className="inline-flex items-center gap-1 rounded-full bg-[#E6F7F6] px-2 py-0.5 text-xs font-medium text-[#15656D]"
        >
          <CheckIcon className="size-3" />
          Conferma immediata
        </span>
      )}
    </>
  );
};
